import SeoArticlePage from '@/pages/article/SeoArticlePage';
import { legitArticle } from '@/mocks/articles';

export default function LegitPage() {
  return <SeoArticlePage article={legitArticle} />;
}